module.exports = __webpack_public_path__ + "img/shield-check-blue.7b4d40fe.svg";